import script from "./UserInfoStats.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoStats.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoStats.vue?vue&type=style&index=0&id=92c43474&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92c43474"]])

export default __exports__